export var OrderDirectionEnum;
(function (OrderDirectionEnum) {
    OrderDirectionEnum[OrderDirectionEnum["ASC"] = 1] = "ASC";
    OrderDirectionEnum[OrderDirectionEnum["DESC"] = -1] = "DESC";
})(OrderDirectionEnum || (OrderDirectionEnum = {}));
